import { observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import { useStores } from '../../hooks/useStores';
import theme from '../../utils/styles/theme';

const styles = () => ({
  root: {
    margin: '0 45px 0 0',
    padding: theme.space[2],
  },
  title: {
    marginLeft: theme.space[2],
    textTransform: 'uppercase',
  },
  closeButton: {
    position: 'absolute',
    padding: theme.space[2],
    right: theme.space[1],
    top: theme.space[1],
    color: theme.colors.blacks[2],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography className={classes.title} variant="h6">
        {children}
      </Typography>

      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles({
  root: {
    padding: theme.space[3],
  },
  instructions: {
    color: theme.colors.blacks[4],
    lineHeight: 1.5,
    marginBottom: theme.space[2],
  },
  muted: {
    fontWeight: 'normal',
    color: theme.colors.blacks[4],
    marginBottom: theme.space[2],
  },
})((props) => {
  const { children, classes, ...other } = props;
  return (
    <MuiDialogContent className={classes.root}>
      {children({ classes, ...other })}
    </MuiDialogContent>
  );
});

const DialogActions = withStyles({
  root: {
    margin: 0,
    padding: theme.space[2],
  },
})(MuiDialogActions);

const ProductDeleteModal = ({ onDeleteClick }) => {
  const { allProductsPage } = useStores();

  const closeDialog = () => {
    allProductsPage.closeProductDeleteModal();
  };
  const numSelectedProducts = allProductsPage.selectedProducts.length;

  return (
    allProductsPage.isDeleteModalOpen && (
      <Dialog open={allProductsPage.isDeleteModalOpen}>
        <DialogTitle
          data-testid="product-delete-dialog-title"
          onClose={closeDialog}
        >
          Remove {numSelectedProducts} product
          {numSelectedProducts > 1 ? 's' : ''}?
        </DialogTitle>
        <DialogContent>
          {({ classes }) => {
            return (
              <>
                <div
                  data-testid="product-delete-dialog-instructions"
                  className={classes.instructions}
                >
                  This can&apos;t be undone.
                </div>
              </>
            );
          }}
        </DialogContent>
        <DialogActions>
          <Button
            data-testid="product-delete-dialog-btn-cancel"
            onClick={closeDialog}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            data-testid="product-delete-dialog-btn-confirm"
            onClick={onDeleteClick}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    )
  );
};

export default observer(ProductDeleteModal);
